import styled from 'styled-components'

export const Brand = styled.div`
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  svg{
    ${props => props.theme.logo}
    width: 100%;
  }
`